import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Scrollbars } from 'react-custom-scrollbars';
import { cartCrossIcon, cartDotedLine } from '../../../assets/images/newImages';
import { useTranslation } from 'react-i18next';
import '../../frontend/scss/cart.scss';
import '../../frontend/scss/qrcode.scss';
// import ublLogo from '../../../assets/images/img';
import { ublLogo,raastLogo,ropayLogo } from '../../../assets/images/img';

function QRCodeDisplay(props) {
    const {
        qrCodeData,
        restaurant,
        closeCartModal,
        currentLanguage,
        restaurantSuccess,
        orderId
    } = props;

    const { t } = useTranslation();
    const [timeLeft, setTimeLeft] = useState(300); // 5 minutes countdown (300 seconds)

    const viewportHeight = window.innerHeight;
    const modalhight = viewportHeight - 44;
    const modalHightDivision = modalhight - 100;

    // Countdown timer effect
    useEffect(() => {
        if (timeLeft <= 0) return;

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    // Format time as MM:SS
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div className='cart-logo'>
                    <img src={restaurant?.logo} className="cart-logo-image" alt="Restaurant Logo" />
                </div>
            </div>

            <div className='cart-main-div-head'>
                <Scrollbars style={{ height: modalHightDivision }}>
                    <div className={currentLanguage?.left_to_right === 0 ? 'cart-head-cross-pay cart-head-cross-pay-rtl' : 'cart-head-cross-pay'}>
                        <h2 className={currentLanguage?.left_to_right === 0 ? 'table-heading pay table-heading-rtl' : 'table-heading pay'}>
                            {t('table')}: 1
                        </h2>
                        <span className='second-modal-cross-svg-style'>
                            <img onClick={closeCartModal} src={cartCrossIcon} alt="Close" />
                        </span>
                    </div>

                    <div className='qr-code-container'>
                        <img src={ublLogo} style={{ width: '80px' }} />
                        <div className='qr-code-header'>
                            <h2 className={currentLanguage?.left_to_right === 0 ? 'qr-heading qr-heading-rtl' : 'qr-heading'}>
                                Scan QR Code to Pay
                            </h2>
                            {/* <p className={currentLanguage?.left_to_right === 0 ? 'qr-subheading qr-subheading-rtl' : 'qr-subheading'}>
                                Use your banking app to scan and complete payment
                            </p> */}
                        </div>

                        <div className='qr-code-wrapper'>
                            <div className='qr-code-box'>
                                {qrCodeData?.qr_code ? (
                                    <QRCodeSVG
                                        value={qrCodeData.qr_code}
                                        size={250}
                                        level="H"
                                        includeMargin={true}
                                        bgColor="#FFFFFF"
                                        fgColor="#092058"
                                    />
                                ) : (
                                    <div className='qr-error'>QR Code not available</div>
                                )}
                            </div>
                        </div>

                        {/* {timeLeft > 0 ? (
                            <div className='qr-timer'>
                                <p className={currentLanguage?.left_to_right === 0 ? 'timer-text timer-text-rtl' : 'timer-text'}>
                                    Time remaining: <span className='timer-value'>{formatTime(timeLeft)}</span>
                                </p>
                            </div>
                        ) : (
                            <div className='qr-expired'>
                                <p>QR Code has expired. Please try again.</p>
                            </div>
                        )} */}

                        <div>
                            <h1 className='amount-heading'>Amount</h1>
                            <div className='amount-heading-doted-circle'>
                                <span className='total-amount'>
                                    {qrCodeData?.currency || restaurantSuccess?.data?.branches[0].currency}.
                                    {parseFloat(qrCodeData?.amount || 0).toFixed(2)}
                                </span>
                            </div>
                        </div>

                        <div className='ropay-logos-div'>
                            <img src={raastLogo} className='ropay-logo-images' />
                            <img src={ropayLogo} className='ropay-logo-images' />  
                        </div>



                        {/* <div className='cart-doted-line-div'> */}
                        {/* <img className='cart-doted-line-div-img' src={cartDotedLine} alt="Divider" /> */}
                        {/* </div> */}

                        {/* <div className='qr-payment-details'> */}
                            {/* <div className='payment-info-row'>
                                <span className={currentLanguage?.left_to_right === 0 ? 'info-label info-label-rtl' : 'info-label'}>
                                    Order ID:
                                </span>
                                <span className='info-value'>
                                    {orderId || 'N/A'}
                                </span>
                            </div> */}

                            {/* {qrCodeData?.alias_value && (
                                <div className='payment-info-row'>
                                    <span className={currentLanguage?.left_to_right === 0 ? 'info-label info-label-rtl' : 'info-label'}>
                                        Alias:
                                    </span>
                                    <span className='info-value'>
                                        {qrCodeData.alias_value}
                                    </span>
                                </div>
                            )} */}

                            {/* <div className='cart-doted-line-div'>
                                <img className='cart-doted-line-div-img' src={cartDotedLine} alt="Divider" />
                            </div> */}

                            {/* <div className={currentLanguage?.left_to_right === 0 ? 'payable-amount-div-rtl payable-amount-div' : 'payable-amount-div'}>
                                <div style={{ paddingLeft: '25px' }}>
                                    <h3 className={currentLanguage?.left_to_right === 0 ? 'paya-head paya-head-rtl' : 'paya-head'}>
                                        Total Amount
                                    </h3>
                                    <p className={currentLanguage?.left_to_right === 0 ? 'paya-parah-rtl paya-parah' : 'paya-parah'}>
                                        (Tax & Tip Included)
                                    </p>
                                </div>
                                <div>
                                    <span className='paya-price-payfully'>
                                        {qrCodeData?.currency || restaurantSuccess?.data?.branches[0].currency}.
                                    </span>
                                    <span className='paya-price-amount'>
                                        {parseFloat(qrCodeData?.amount || 0).toFixed(2)}
                                    </span>
                                </div>
                            </div> */}
                        {/* </div> */}

                        {/* <div className='qr-instructions'>
                            <h4 className={currentLanguage?.left_to_right === 0 ? 'instructions-heading instructions-heading-rtl' : 'instructions-heading'}>
                                How to Pay:
                            </h4>
                            <ol className={currentLanguage?.left_to_right === 0 ? 'instructions-list instructions-list-rtl' : 'instructions-list'}>
                                <li>Open your banking app</li>
                                <li>Select "Scan & Pay" or "QR Payment"</li>
                                <li>Scan the QR code above</li>
                                <li>Confirm the payment amount</li>
                                <li>Complete the transaction</li>
                            </ol>
                        </div> */}

                        {/* <div className='qr-footer'>
                            <p className={currentLanguage?.left_to_right === 0 ? 'footer-text footer-text-rtl' : 'footer-text'}>
                                Do not close this window until payment is confirmed
                            </p>
                        </div> */}
                    </div>
                </Scrollbars>
            </div>
        </>
    );
}

export default QRCodeDisplay;
